const Backbone = require('backbone');
const FinishModel = require('app/models/store/client/product/finish');
const FinishesCollection = Backbone.Collection.extend({
	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.setSelectedFinish);
	},

	model: FinishModel,

	/**
	 * hasSelectedFinish - shortcut to determine whether a finish is active
	 * @return {Boolean} If the number of Finish models that are selected is > 0
	 */
	hasSelectedFinish: function() {
		// Select the first model where isSelected is true
		return (
			this.findWhere({
				selected: true
			}) !== undefined
		);
	},

	/**
	 * getSelectedFinish - get the currently selected finish
	 * @return {Object} Finish Model
	 */
	getSelectedFinish: function() {
		return this.findWhere({
			selected: true
		});
	},

	/**
	 * setSelectedFinish - set the currently selected finish
	 * @param  {Object} data     The new selected finish model
	 * @return {Object}  Finish Model
	 */
	setSelectedFinish: function(data) {
		let finish = this.getFinishByUniqueId(data.uniqueId);

		// Not allow users to select nonstock finishes for paint
		if (finish && finish.get('isPaint') && finish.get('status').toLowerCase() === 'nonstock') {
			return;
		}

		this.trigger('finishSelected', data);
		this.each(function(model) {
			model.set({
				selected: false
			});
		});

		if (finish) {
			finish.set({
				selected: true
			});
		}
	},

	/**
	 * getFinishByUniqueId - get the Finish model by UniqueId
	 * @return {Object} Finish Model
	 */
	getFinishByUniqueId: function(uniqueId) {
		return this.findWhere({
			uniqueId: uniqueId
		});
	},

	/**
	 * getHoveredFinish - get the finish model that has been hovered but not selected
	 * @returns {FinishModel}
	 */
	getHoveredFinish: function() {
		return this.find((finish) => finish.get('hovered'));
	}
});
module.exports = FinishesCollection;
